import {Application} from "./Application";
import {ExclaimApplication} from "./ExclaimApplication";

// Initialize the "EX" structure where a bunch of common exclaim stuff is stored
export const EX: Application = new ExclaimApplication();

// Avoid using this, but it's still needed by some bits of code (e.g.: PersonMatch.js)
declare global {
    // noinspection JSUnusedGlobalSymbols
    interface Window {
        EX: Application;
    }
}
if (typeof window !== "undefined") {
    window.EX = EX;
}
